<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="sign-confirm-wrapper">
    <section class="sign-confirm-body">
      <screen-shot ref="screenShot">
        <section class="result-table-wrapper">
          <section class="result-table-header">
            <h1 style="font-size:24px;margin:1em;">中国环境监测总站</h1>

            <section style="font-size:24px;margin:1em;">国家光化学监测网VOCs自动监测质控现场检查评分表</section>

            <section class="site-info-wrapper">
              <span style="float:left;">
                <span class="site-info-label">城市类别:</span>
                <span class="site-info-description">{{task.siteTypeName}}</span>
              </span>

              <span>
                <span class="site-info-label">所属省份:</span>
                <span class="site-info-description">{{task.areaName}}</span>
              </span>

              <span style="float:right;">
                <span class="site-info-label">站点名称:</span>
                <span class="site-info-description">{{task.siteName}}</span>
              </span>
            </section>
          </section>

          <table class="check-item-table">
            <colgroup>
              <col width="39" />
              <col width="102" />
              <col width="93" />
              <col width="151" />
              <col width="53" />
              <col />
<!--              <col width="335" />-->
            </colgroup>
            <thead>
            <tr>
              <th>序号</th>
              <th colspan="2">检查项目</th>
              <th>检查内容</th>
              <th>满分值</th>
              <th>检查结果</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(checkItem, index) in checkItemList"
              :key="index"
            >
              <td
                v-if="checkItem.dataIndex"
                :rowspan="checkItem.rowSpans"
                align="center"
                valign="middle"
              >{{checkItem.dataIndex}}</td>
              <td
                v-if="checkItem.dataIndex"
                :rowspan="checkItem.rowSpans"
                align="center"
                valign="middle"
              >{{checkItem.categoryName}}</td>
              <td
                v-if="checkItem.deviceRowSpans"
                :rowspan="checkItem.deviceRowSpans"
                align="center"
                valign="middle"
              >{{checkItem.deviceCategoryName}}</td>
              <td align="center" valign="middle">{{checkItem.content}}</td>
              <td align="center" valign="middle">{{checkItem.fullMarks}}</td>
              <td align="center" valign="middle">
                <div
                  v-for="(opt, index) in checkItem.opts"
                  :key="index"
                >{{opt}}</div>
              </td>
            </tr>
            </tbody>
          </table>

          <section class="result-table-footer">
            <section class="sign-item">
              <span class="sign-text" style="float:left;">
                <span class="sign-label">检查方(签名)</span>
                <span :style="`background-image:url(${sign.inspectSign})`" class="sign-img"></span>
              </span>
              <span class="sign-date">{{signDate}}</span>
            </section>
            <section class="sign-item">
              <span class="sign-text" style="float:left;">
                <span class="sign-label">运维方(签名)</span>
                <span :style="`background-image:url(${sign.operationSign})`" class="sign-img"></span>
              </span>
              <span class="sign-date">{{signDate}}</span>
            </section>
            <section class="sign-item">
              <span class="sign-text" style="float:left;">
                <span class="sign-label">驻地监测单位(签名)</span>
                <span :style="`background-image:url(${sign.ownerSign})`" class="sign-img"></span>
              </span>
              <span class="sign-date">{{signDate}}</span>
            </section>
          </section>
        </section>
      </screen-shot>
    </section>

    <section style="position:fixed;top:70px;width:100%;padding:10px 20px 0;background-color:#f7f8fa;z-index:9;">
      <van-button
        type="primary"
        style="width:100%;"
        @click="onSaveSubmit"
      >完成</van-button>
    </section>

    <section class="sign-confirm-footer">
      <section class="sign-btn" @click="onSignBtnClick('inspectSign', '检查方签名')">检查方签名</section>
      <section class="sign-btn" @click="onSignBtnClick('operationSign', '运维方签名')">运维方签名</section>
      <section class="sign-btn" @click="onSignBtnClick('ownerSign', '驻地监测单位签名')">驻地监测单位签名</section>
    </section>
  </section>

  <sign-canvas
    v-if="signCanvasVisible"
    :title="signCanvasTitle"
    style="z-index:10;"
    @back="signCanvasVisible = false"
    @ok="onSignFinished"
  />

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {Dialog} from 'vant'

import SignCanvas from './SignCanvas'

import checkOptTypeMap from '../../components/Data/TaskResult/CheckOptTypeMap'

export default {
  name: 'index',
  routeInfo: {
    label: '签字确认'
  },
  components: {
    SignCanvas
  },
  data () {
    return {
      checkItemList: [],
      signDate: new Date().format('YYYY年MM月DD日'),
      signCanvasVisible: false,
      signCanvasTitle: '',
      sign: {
        inspectSign: '',
        operationSign: '',
        ownerSign: ''
      },
      overlayVisible: false
    }
  },
  computed: {
    ...mapGetters({
      task: 'Task/task'
    }),
    checkOptTypeMap: () => checkOptTypeMap,
    isNotSignFinished () {
      return Object.values(this.sign).some(img => img === '')
    }
  },
  methods: {
    getCheckItemCategories () {
      this.$api.Grade.getTaskDetail(this.task.id).then(this.setCheckList).catch(console.error)
    },
    setSignObj (task) {
      let {sign} = this

      for (let key in sign) {
        sign[key] = task[key] || ''
      }

      this.$store.commit('Task/setTask', task)
    },
    setCheckList ({checkItems: checkItemCategories}) {
      let formatCheckItemList = []

      checkItemCategories.forEach((checkItemCategory, categoryIndex) => {
        let deviceCategories = checkItemCategory.deviceCategories
        let rootRowSpans = deviceCategories.reduce((count, deviceCategory) => count + deviceCategory.checkItems.length, 0)

        deviceCategories.forEach((deviceCategory, deviceCategoryIndex) => {
          let checkItems = deviceCategory.checkItems

          checkItems.forEach((checkItem, checkItemIndex, checkItems) => {
            let util = checkOptTypeMap[checkItem.optionTypeId]
            let checkItemData = {
              id: checkItem.id,
              content: checkItem.content,
              description: checkItem.description,
              fullMarks: checkItem.fullMarks,
              opts: util ? util.getSelected(checkItem) : []
            }

            if (checkItemIndex === 0) {
              checkItemData.deviceCategoryId = deviceCategory.id
              checkItemData.deviceCategoryName = deviceCategory.name
              checkItemData.deviceRowSpans = checkItems.length

              if (deviceCategoryIndex === 0) {
                checkItemData.categoryId = checkItemCategory.id
                checkItemData.categoryName = checkItemCategory.name
                checkItemData.rowSpans = rootRowSpans
                checkItemData.dataIndex = categoryIndex + 1
              }
            }

            // console.log(checkItemData)
            formatCheckItemList.push(checkItemData)
          })
        })
      })

      this.checkItemList = Object.freeze(formatCheckItemList)
    },
    onSignBtnClick (signField, title) {
      this.signCanvasVisible = true
      this.signField = signField
      this.signCanvasTitle = title
    },
    onSignFinished (base64) {
      this.overlayVisible = true

      let {sign, task, signField} = this
      sign[signField] = base64
      this.signCanvasVisible = false

      this.$api.TaskSign.saveSign({
        id: task.id,
        [signField]: base64
      }).then(data => {}).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onSaveSubmit () {
      if (this.isNotSignFinished) {
        Dialog.confirm({
          title: '确认',
          message: '签名未全部完成，是否继续退到首页面'
        }).then(() => {
          this.$router.replace({
            name: 'SiteSelector'
          })
        }).catch(() => {})
      } else {
        this.overlayVisible = true

        this.$api.TaskSign.saveSignResult({
          id: this.task.id
        }).then(data => {
          this.$router.replace({
            name: 'SiteSelector'
          })
        }).catch(console.error).finally(() => {
          this.overlayVisible = false
        })
      }
    }
  },
  created () {
    this.getCheckItemCategories()

    this.$api.Task.getDetail(this.task.id).then(this.setSignObj).catch(console.error)
  }
}
</script>

<style lang="scss" scoped>
.sign-confirm-wrapper {
  $SIGN-CONFIRM-WRAPPER-HEIGHT: 40px;

  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: $SIGN-CONFIRM-WRAPPER-HEIGHT;
  background-color: #f7f8fa;

  .sign-confirm-body {
    width: 100%;
    height: 100%;
    padding: 72px 20px 20px;
    overflow: auto;
  }

  .result-table-wrapper {
    width: 21cm;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
    background-color: #FFFFFF;
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, .15);

    .result-table-footer {
      font-size: 14px;
      margin-top: 1.5em;
      padding: 0 20px;
    }
  }

  .site-info-wrapper {
    font-size: 14px;
    margin: 1em 0 .5em;
    padding: 0 20px;
    text-align: center;

    .site-info-label {
      /*padding: 0 5px 0 0;*/
      /*vertical-align: middle;*/
    }

    .site-info-description {
      /*display: inline-block;*/
      /*min-width: 100px;*/
      /*height: 21px;*/
      padding: 0 5px;
      /*border-bottom: 1px solid #323233;*/
      /*vertical-align: middle;*/
      text-align: left;
    }
  }

  .check-item-table {
    font-size: 14px;
    width: 100%;
    /*border: 1px solid #E3E9ED {*/
    /*  right: 0;*/
    /*  bottom: 0;*/
    /*  spacing: 0;*/
    /*};*/
    border: 1px solid #000 {
      right: 0;
      bottom: 0;
      spacing: 0;
    };

    th,
    td {
      padding: 3px 5px;
      /*border: {*/
      /*  right: 1px solid #E3E9ED;*/
      /*  bottom: 1px solid #E3E9ED;*/
      /*}*/
      border: {
        right: 1px solid #000;
        bottom: 1px solid #000;
      }
    }

    th {
      white-space: nowrap;
    }
  }

  .sign-item {
    line-height: 2.5em;

    &:after {
      content: "";
      display: table;
      clear: both;
    }

    .sign-text {
      float: left;

      .sign-img {
        display: inline-block;
        width: 450px;
        height: 44px;
        vertical-align: middle;
        background: {
          size: contain;
          repeat: no-repeat;
        }
      }
    }

    .sign-date {
      float: right;
    }
  }

  .sign-confirm-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: $SIGN-CONFIRM-WRAPPER-HEIGHT;
    border-top: 1px solid #cfd0d3;
    background-color: #FFF;

    .sign-btn {
      float: left;
      width: 33.3333%;
      height: 100%;
      line-height: $SIGN-CONFIRM-WRAPPER-HEIGHT;
      text-align: center;

      &:not(:last-child) {
        border-right: 1px solid #cfd0d3;
      }

      &:active {
        color: #3a8ee6;
        background-color: #ecf5ff;
      }
    }
  }
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/08Sign/index.vue